export enum AdCategoryNames {
  HOME = 'Home',
  NEWS = 'News',
  NEWS_ARTICLE = 'Article Page',
  NEWS_CATEGORY = 'News Category',
  GAMES = 'Games',
  GAMES_CATEGORY = 'Games Category',
  DEALS = 'Deals',
  DEALS_CATEGORY = 'Deals Category',
  HOROSCOPE = 'Horoscope'
}

export enum HomeAdUnits {
  BANNER_ATF = 'home-banner-atf',
  MREC_ATF = 'home-mrec-atf',
  MREC_BTF = 'home-mrec-btf',
  MREC_MID1 = 'home-mrec-mid1',
  MREC_MID2 = 'home-mrec-mid2',
  MREC_MID3 = 'home-mrec-mid3',
  MREC_MID4 = 'home-mrec-mid4',
  MREC_MID5 = 'home-mrec-mid5',
  HOME_STICKY_BANNER = 'home-stickybanner'
}

export enum NewsAdUnits {
  HOMEPAGE_MREC_ATF = 'news_homepage-mrec-atf',
  HOMEPAGE_MREC_MID1 = 'news_homepage-mrec-mid1',
  HOMEPAGE_MREC_MID2 = 'news_homepage-mrec-mid2',
  HOMEPAGE_FEED = 'news_homepage-mrec-healines_feeds',
  CATEGORYPAGE_STICKY_BANNER = 'news_category-stickybanner',
  CATEGORYPAGE_VIEWALL_FEED = 'news_category_viewall_feed',
  CATEGORYPAGE_VIEWALL_STICKYBANNER = 'news_category_viewall_stickybanner'
}

export enum NewsArticleAdUnits {
  MREC_ATF = 'article-mrec-atf',
  STICKY_BANNER = 'article-stickybanner',
  MREC_MID_SCROLL = 'article-mrec-midscroll',
  MREC_END = 'news-artcle-mrec-end',
  MREC_BTF = 'article-mrec-btf',
  VIEWALL_FEED = 'news_category_viewall_feed',
  L2_STICKY_BANNER = 'news-l2-stickybanner',
  L2_INTERSCROLLER = 'NewsL2_interscroller_btf1'
}

export enum GamesAdUnits {
  HOMEPAGE_MREC_ATF = 'games_homepage-mrec-atf',
  HOMEPAGE_MREC_MID1 = 'games_homepage-mrec-mid1',
  HOMEPAGE_MREC_MID2 = 'games_homepage-mrec-mid2',
  HOMEPAGE_GAME_FEED = 'games_homepage-game-feeds',
  CATEGORYPAGE_STICKY_BANNER = 'games_category-stickybanner',
  CATEGORYPAGE_VIEWALL_FEED = 'games_category_viewall_feed',
  CATEGORYPAGE_VIEWALL_STICKY_BANNER = 'games_category_viewall_stickybanner'
}

export enum DealsAdUnits {
  HOMEPAGE_MREC_ATF = 'deals_homepage-mrec-atf',
  HOMEPAGE_MREC_MID1 = 'deals_homepage-mrec-mid1',
  HOMEPAGE_MREC_FEED = 'deals_homepage-mrec-feeds',
  CATEGORYPAGE_STICKY_BANNER = 'deals_category-sticky-banner',
  CATEGORYPAGE_VIEWALL_FEED = 'deals_category_viewall_feed'
}

export enum HoroscopeAdUnits {
  MREC_ATF = 'horoscope_category-mrec-atf',
  BANNER_FEEDS = 'horoscope_category-banner-feeds',
  BANNER_DETAILSFEED = 'horoscope_category-banner-detailfeeds',
  STICKY_BANNER = 'horoscope_category-stickybanner'
}

export enum VideoInstreamAds {
  NEWS_VIDEOCONTENT_PREROLL_INSTREAM = 'news_videocontent_PreRoll_instream'
}
